import product1 from "../img/Duphalac-image-new.png";
import product2 from "../img/coreDiag.png";
import product3 from "../img/cov.jpg";
import product4 from "../img/Similac_300x225.jpg";
import product5 from "../img/Duphaston-new.jpeg";
import product6 from "../img/Duphalac-image-new.png";
import product_lev_1 from "../img/Company_B/levis_one.png"
import product_lev_2 from "../img/Company_B/levis_max_forte.png"
import product_lev_3 from "../img/Company_B/levis_care.png"
import calendar1 from "../scripts/duphalac.ics";
import calendar2 from "../scripts/alinity-m-hcv-assay.ics";
import calendar3 from "../scripts/binaxnow.ics";
import calendar4 from "../scripts/similac.ics";
import calendar5 from "../scripts/duphaston.ics";
import calendar6 from "../scripts/duphalac-exp.ics";
import calendar7 from "../scripts/duphaston-ex.ics";

export const abbottProducts = [
  {
    //08691234123416
    id: 1,
    // name: "DUPHALAC® SOLUTION 300 ml",
    name: (
      <>
        DUPHALAC<sup>®</sup> SOLUTION
      </>
    ),
    scanCountExceed: false,
    verified: true,
    quality: true,
    image: product1,
    // description: "DUPHALAC® SOLUTION 300 ml",
    description: (
      <>
        DUPHALAC<sup>®</sup> SOLUTION 300 ml
      </>
    ),
    sublabel: "This is an Abbott EPD product.",
    gtin: "08691234123416",
    lot: "D0625005",
    serial: "5652145895641",
    expDate: "24 Aug 2027",
    calendar: calendar1,
    leaflet: "https://www.arabia.abbott/ar/homepage.html?gtin=8002660041012",
    productPage: "https://www.duphalac.com/products/duphalac-solution/",
  },
  {
    //00380740153885
    id: 2,
    name: "Alinity m HCV Assay",
    scanCountExceed: false,
    verified: true,
    quality: true,
    image: product2,
    description: "Alinity m HCV Assay-060000-0140-1500",
    sublabel: "This is an Abbott Core Diagnostics product.",
    gtin: "00380740153885",
    lot: "A2505204",
    serial: "5652145895642",
    expDate: "10 Jun 2027",
    calendar: calendar2,
    leaflet:
      "https://val-cdn.pepperapps.io/abbottepd-eleaflet/public/653f787b9d3bc52d68a1ce37?signature=eyJhbGciOiJkaXIiLCJlbmMiOiJBMTI4Q0JDLUhTMjU2In0..-EpstXCjmKuE7Z0o1NBGDQ.Ir0_NR3sTIP7HXtmezxeMMkEeKRU3-vGKhylRURtGmkdBLQywooDyRN172nrWr6OEp6chkla8O9ZG13FxLxHJN4e0dZgNdh5PGtXTIczOe4Rh4GCOPxyHzjZOaAcWRfD_9vjdriGfnJUoptsXTse46A3gKdLwpyA03eYZqgbg1vZ5KOdUFBobO2zn-gPAE8SSwGbBhAVRTVFZzXqbuApdQ.q9neI6PkOlGvA_tAAcsuFQ",
    productPage:
      "https://www.corelaboratory.abbott/int/en/offerings/brands/alinity.html",
  },
  {
    //00813337019511
    id: 3,
    name: "BINAXNOW COVID-19 ANTIGEN SELF TEST",
    scanCountExceed: false,
    verified: true,
    quality: true,
    sublabel: "This is an Abbott Rapid Diagnostics product.",
    image: product3,
    description: "BINAXNOW covid-19 antigen self test-077700-0140-2000",
    gtin: "00813337019511",
    lot: "B0825451",
    serial: "5652145895643",
    expDate: "27 May 2027",
    calendar: calendar3,
    leaflet: "https://www.fda.gov/media/141570/download",
    productPage:
      "https://www.globalpointofcare.abbott/en/product-details/binaxnow-covid-19-antigen-self-test-us.html",
  },
  {
    //00813337016046
    id: 4,
    name: "Similac 3 1800 gr",
    scanCountExceed: false,
    verified: true,
    quality: true,
    image: product4,
    sublabel: "This is an Abbott Nutrition product.",
    description: "Similac 3 1800 gr-084400-0140-0000",
    gtin: "00813337016046",
    lot: "S2509667",
    serial: "5652145895644",
    expDate: "10 Sept 2027",
    calendar: calendar4,
    leaflet:
      "https://www.abbottnutrition.ie/downloads/2563_Similac_Recipe_Book_PROOF.pdf",
    productPage: "https://www.similac.com/home.html",
  },
  {
    //00813337017142 verified
    id: 5,
    name: "DUPHASTON 10 mg",
    scanCountExceed: false,
    verified: true,
    quality: true,
    sublabel: "This is an Abbott EPD product.",
    image: product5,
    description: "Duphaston (Dydrogesterone) 10mg",
    gtin: "00813337017142",
    lot: "B1000523",
    serial: "2235689556554",
    expDate: "30 Apr 2027",
    calendar: calendar5,
    leaflet: "https://www.arabia.abbott/ar/homepage.html?gtin=8002660042170",
    productPage: "https://www.medicine.abbott/cl/products/duphaston.html",
  },

  {
    // 08002660043863 expired product
    id: 6,
    // name: "DUPHALAC® SOLUTION 300 ml",
    name: (
      <>
        DUPHALAC<sup>®</sup> SOLUTION
      </>
    ),
    scanCountExceed: false,
    verified: false,
    quality: true,
    sublabel: "This is an Abbott EPD product.",
    image: product6,
    // description: "DUPHALAC® SOLUTION 300 ml",
    description: (
      <>
        DUPHALAC<sup>®</sup> SOLUTION 300 ml
      </>
    ),
    gtin: "08002660043863",
    lot: "00123456",
    serial: "1234567890123",
    expDate: "31 Jan 2023",
    calendar: calendar6,
    leaflet: "https://www.arabia.abbott/ar/homepage.html?gtin=8002660041012",
    productPage: "https://www.duphalac.com/products/duphalac-solution/",
  },
  {
    //00813337017143 count exceeded added fake gtin for demo
    id: 7,
    name: "DUPHASTON 10 mg",
    scanCountExceed: true,
    verified: false,
    quality: true,
    sublabel: "This is an Abbott EPD product.",
    image: product5,
    description: "Duphaston (Dydrogesterone) 10mg",
    gtin: "00813337017143",
    lot: "B1000523",
    serial: "2235689556553",
    expDate: "30 Apr 2027",
    calendar: calendar7,
    leaflet: "https://www.arabia.abbott/ar/homepage.html?gtin=8002660042170",
    productPage: "https://www.medicine.abbott/cl/products/duphaston.html",
  },
  {
    //00813337017143 count exceeded added fake gtin for demo
    id: 8,
    name: "DUPHASTON 10 mg",
    scanCountExceed: true,
    verified: false,
    quality: true,
    sublabel: "This is an Abbott EPD product.",
    image: product5,
    description: "Duphaston (Dydrogesterone) 10mg",
    gtin: "00813337017142",
    lot: "B1000523",
    serial: "2235689556553",
    expDate: "30 Apr 2027",
    calendar: calendar7,
    leaflet: "https://www.arabia.abbott/ar/homepage.html?gtin=8002660042170",
    productPage: "https://www.medicine.abbott/cl/products/duphaston.html",
  },
];

export const lewisProducts = [
  {
    id: 101,
    name: (
      <>
        LEWIS ONE<sup>®</sup>
      </>
    ),
    nameString: "LEWIS ONE",
    description: "Premium Levi's craftsmanship meets timeless style in this deep blue, button-fly essential.",
    sublabel: "Classic Indigo Button-Fly Denim",
    serial: "7891234567890",
    gtin: "05012345678900",
    lot: "L789012",
    expDate: "15 Dec 2026",
    calendar: calendar1,
    leaflet: "https://example.com/lewis-one-leaflet.pdf",
    productPage: "https://example.com/lewis-one",
    image: product_lev_1,
    company: 2
  },
  {
    id: 102,
    name: (
      <>
        LEWIS MAX<sup>®</sup> FORTE
      </>
    ),
    nameString: "LEWIS MAX FORTE",
    description: "A bold blend of vintage charm and modern fit, these jeans offer structured comfort with a classic silhouette.",
    sublabel: "High-Rise Straight-Leg Retro Denim",
    serial: "7891234567891",
    gtin: "05012345678917",
    lot: "L789013",
    expDate: "20 Jan 2027",
    calendar: calendar2,
    leaflet: "https://example.com/lewis-max-leaflet.pdf",
    productPage: "https://example.com/lewis-max",
    image: product_lev_2,
    company: 2
  },
  {
    id: 103,
    name: (
      <>
        LEWIS CARE<sup>®</sup>
      </>
    ),
    nameString: "LEWIS CARE",
    description: "Effortlessly stylish and versatile, this light denim shirt blends comfort with Levi’s iconic craftsmanship.",
    sublabel: "Classic Chambray Button-Down Shirt",
    serial: "7891234567892",
    gtin: "05012345678924",
    lot: "L789014",
    expDate: "10 Mar 2027",
    calendar: calendar3,
    leaflet: "https://example.com/lewis-care-leaflet.pdf",
    productPage: "https://example.com/lewis-care",
    image: product_lev_3,
    company: 2
  }
];

// Combined product list for backward compatibility
export const productList = [...abbottProducts, ...lewisProducts];
